import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useSessionStore } from 'store/session';
import { MeterReplacementPage } from 'routes/meter_replacement/Page';
import { ServiceInspectionPage } from 'routes/service_inspection/Page';
import { ReadingGroupDetailPage } from 'routes/reading_groups/detail/Page';
import { useBrowserDetection } from 'hooks/useBrowserDetection';
import { NotFoundPage } from './routes/not_found/NotFoundPage';
import { AuthPage } from './routes/auth/AuthPage';
import { CrossroadPage } from './routes/crossroad_menu/CrossroadPage';
import { InventorizeMeterPage } from './routes/inventorize_meter/Page';
import { InstallMeterPage } from './routes/installation/Page';
import { MeterDetailPage } from './routes/meter_detail/Page';
import { MeterIdentificationPage } from './routes/meter_identification/Page';
import { MeterListPage } from './routes/meter_list/Page';
import { CreateReadingGroupPage } from './routes/reading_groups/create/Page';
import { ReadingGroupListPage } from './routes/reading_groups/Page';
import { useMeterModels } from './hooks/meter_models/useMeterModels';

export const App: React.FC = () => {
  const { isAuthenticated } = useSessionStore();

  // Load meter models to have them in indexed DB for offline usage
  useMeterModels(undefined, { enabled: isAuthenticated });

  useBrowserDetection();

  return (
    <div className="App">
      {!isAuthenticated ? (
        <AuthPage />
      ) : (
        <Routes>
          <Route index element={<CrossroadPage />} />
          <Route path="inventorize">
            <Route element={<InventorizeMeterPage />} path="" />
            <Route element={<InventorizeMeterPage />} path=":id" />
          </Route>
          <Route path="reading-groups">
            <Route element={<ReadingGroupListPage />} path="" />
            <Route element={<CreateReadingGroupPage />} path="create" />
            <Route element={<ReadingGroupDetailPage />} path=":id" />
          </Route>
          <Route element={<InstallMeterPage />} path="installation/:id" />
          <Route element={<MeterIdentificationPage />} path="meter-identification" />
          <Route element={<MeterListPage />} path="meters-list" />
          <Route element={<MeterDetailPage />} path="meter/:id" />
          <Route element={<MeterReplacementPage />} path="meter-replacement/:id" />
          <Route element={<ServiceInspectionPage />} path="service-inspection/:id" />
          <Route element={<NotFoundPage />} path="*" />
        </Routes>
      )}
    </div>
  );
};
